import { localize } from 'vee-validate'
import de from 'vee-validate/dist/locale/de.json'
import en from 'vee-validate/dist/locale/en.json'

const CHANGE_LOCALE = "CHANGE_LOCALE";

export default {
    namespaced: true,

    state: {
        locale: localStorage.getItem('locale') || 'de'
    },
    mutations: {
        [CHANGE_LOCALE] (state, language) {
            state.locale = language;
        },
    },
    getters: {
        lang (state) {
            return state.locale
        }
    },
    actions: {
        changeLocale ({commit}, language) {

            localize(language, language === 'en' ? en : de);   // VeeValidate

            axios.get('/api/set_language/' + language)
                .then(response => {
                    // If cookie consent not set - reload page on language change for translation of cookie consent view
                    if (!response.data.cookie_consent_set) {
                        window.location.reload();
                    }
                });

            return new Promise((resolve, reject) => {
                localStorage.setItem('locale', language);
                commit(CHANGE_LOCALE);
                resolve('Success');
            });
        }
    }
}
